import { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const META = {
  tr: {
    title: "CDN Bilişim | Web ve Mobil Uygulama Geliştirme Ajansı",
    description: "Özel web geliştirme, iOS/Android mobil uygulamalar ve ölçeklenebilir yazılım mimarileri. Fikrinizden canlıya, uçtan uca teknoloji ortağınız.",
  },
  en: {
    title: "CDN Bilişim | Web & Mobile App Development Agency",
    description: "Custom web development, iOS/Android mobile apps and scalable software architectures. Your end-to-end technology partner, from idea to launch.",
  },
  ar: {
    title: "CDN Bilişim | وكالة تطوير الويب وتطبيقات الجوال",
    description: "تطوير مواقع ويب مخصصة، تطبيقات iOS/Android، وبنى برمجية قابلة للتوسع. شريكك التقني المتكامل من الفكرة إلى الإطلاق.",
  },
};

const langPath = (l) => (l === "tr" ? "/" : `/${l}`);

function upsertLink(rel, hreflang, href) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    if (hreflang) el.hreflang = hreflang;
    document.head.appendChild(el);
  }
  el.href = href;
}

export function LanguageProvider({ lang, children }) {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.title = META[lang].title;

    let desc = document.head.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content = META[lang].description;

    const origin = window.location.origin;
    upsertLink("canonical", null, `${origin}${langPath(lang)}`);
    upsertLink("alternate", "tr", `${origin}/`);
    upsertLink("alternate", "en", `${origin}/en`);
    upsertLink("alternate", "ar", `${origin}/ar`);
    upsertLink("alternate", "x-default", `${origin}/`);
  }, [lang]);

  const setLang = (l) => navigate(langPath(l));

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
